import { userData } from "../utils/service";

export const INSUFFICIENT_FUNDS_TITLE = "Insufficient funds";
export const INSUFFICIENT_FUNDS_TEXT = "Please deposit and try again";

// Fresh balance from /me (TokenAuth + live GetBalance on every call, nothing cached).
// Returns a number, or null whenever the balance can't be read - callers must then
// continue with the normal join flow, never claim insufficient funds.
export const fetchFreshBalance = async (playerId, token) => {
  try {
    const res = await userData({ token_id: token, player_id: playerId }, token, playerId);
    if (!res || res.__apiError) return null;
    const raw = res.balance;
    if (raw === null || raw === undefined || raw === "") return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch (e) {
    return null;
  }
};

// Same boundary as the backend's join_game (`amount > balance`), compared in cents.
export const isShortOfFunds = (balance, stake, entries) => {
  const cost = Number(stake) * Number(entries);
  if (!Number.isFinite(cost) || cost <= 0 || balance === null) return false;
  return Math.round(balance * 100) < Math.round(cost * 100);
};
